export const categories = [
  {
    id: 'all',
    name: '全部',
    icon: 'ri-grid-line',
    description: '浏览所有麻将游戏类型',
  },
  {
    id: 'classic',
    name: '经典麻将',
    icon: 'ri-ancient-gate-line',
    description: '正宗中国经典麻将玩法，还原最原汁原味的麻将体验',
  },
  {
    id: 'regional',
    name: '地方麻将',
    icon: 'ri-map-pin-line',
    description: '各地特色麻将玩法，四川、广东、上海、台湾等地方规则',
  },
  {
    id: 'international',
    name: '国际麻将',
    icon: 'ri-global-line',
    description: '国际流行的麻将玩法，适合了解不同国家的麻将文化',
  },
  {
    id: 'single',
    name: '单机麻将',
    icon: 'ri-smartphone-line',
    description: '无需联网，随时随地与AI对战，享受单人麻将乐趣',
  },
];